module.exports = __webpack_public_path__ + "static/media/cwug3.2f49c669.jpg";